// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Header from '../components/header';
// import Footer from '../components/footer';
// import { MdEdit, MdDelete,MdOutlinePendingActions  } from "react-icons/md";
// import { HiArrowCircleDown } from "react-icons/hi";
// import { IoIosPrint } from "react-icons/io";
// import Colors from '../components/Colors';
// import './styesheet.css';
// import { pdfLink } from '../components/Strings';

// const BillPage = () => {
//   const [bills, setBills] = useState([]);
//   const [filteredBills, setFilteredBills] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [dateFilter, setDateFilter] = useState('Today');
//   const navigate = useNavigate();
// const [selectedInvoices, setSelectedInvoices] = useState([]);

// const toggleInvoiceSelection = (id) => {
//   setSelectedInvoices((prev) =>
//     prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
//   );
// };

// const handleBulkPrint = () => {
//   if (selectedInvoices.length === 0) return;
//   const ids = selectedInvoices.join(",");
//   const url = `${pdfLink}/printInvoicesBulk.php?ids=${ids}`;
//   window.open(url, "_blank");
// };
// const handleBulkLoadsheet = () => {
//   if (selectedInvoices.length === 0) return;
//   const ids = selectedInvoices.join(",");
//   const url = `${pdfLink}/loadsheetBulk.php?ids=${ids}`;
//   window.open(url, "_blank");
// };

// const handleBulkDelete = async () => {
//   if (selectedInvoices.length === 0) return;
//   const ids = selectedInvoices.join(",");
//   const response = await fetch(
//     `https://app.mirzawaleed.com/deleteBillsBulk.php?ids=${ids}`
//   );
//   const data = await response.json();
//   if (data.success) {
//     window.location.reload();
//   } else {
//     console.error(data.message);
//   }
// };

//   useEffect(() => {
//     const fetchBills = async () => {
//       try {
//         const response = await fetch('https://app.mirzawaleed.com/getBills.php');
//         const data = await response.json();
//         if (data.success) {
//           setBills(data.bills);
//           setFilteredBills(data.bills);
//         } else {
//           console.error(data.message);
//         }
//       } catch (error) {
//         console.error('Error fetching bills:', error);
//       }
//     };

//     fetchBills();
//   }, []);

//   const handleSearch = (e) => {
//     setSearchTerm(e.target.value);
//     filterBills(e.target.value, dateFilter);
//   };

//   const handleDateFilter = (filter) => {
//     setDateFilter(filter);
//     filterBills(searchTerm, filter);
//   };

//   const filterBills = (searchTerm, dateFilter) => {
//     let filtered = bills;

//     if (searchTerm) {
//       const lowerCaseSearchTerm = searchTerm.toLowerCase();
//       filtered = filtered.filter(bill =>
//         bill.id.toString().includes(lowerCaseSearchTerm) ||
//         bill.customer_name.toLowerCase().includes(lowerCaseSearchTerm)
//       );
//     }

//     setFilteredBills(filtered);
//   };

//   const handlePrint = async (invoiceId, customerId) => {
//     const url = `${pdfLink}/printInvoice.php?invoice_id=${invoiceId}&customer_Id=${customerId}`;
//     window.open(url, '_blank');
//   };

//   const handlePrintLoad = async (invoiceId, customerId) => {
//     const url = `${pdfLink}/loadsheet.php?invoice_id=${invoiceId}`;
//     window.open(url, '_blank');
//   };

//   const handleEdit = (invoiceId) => {
//     navigate(`/edit-invoice/${invoiceId}`);
//   };

//   const handleDelete = async (invoiceId) => {
//     try {
//       const response = await fetch(`https://app.mirzawaleed.com/deleteBills.php?id=${invoiceId}`);
//       const data = await response.json();

//       if (data.success) {
//         window.location.reload();
//       } else {
//         console.error(data.message);
//       }
//     } catch (error) {
//       console.error('Error deleting the bill:', error);
//     }
//   };

//   const handleDetails = (invoiceId) => {
//     navigate(`/invoice/${invoiceId}`);
//   };

//   // Placeholder function for "With Pending"
//   const handleWithPending = async (invoiceId, customerId) => {
//     const pending = true;
//     const url = `${pdfLink}/printInvoice.php?invoice_id=${invoiceId}&customer_Id=${customerId}&with_pending=${pending}`;
//     window.open(url, '_blank');
//   };

//   return (
//     <>
//       <Header />
//       <br /><br /><br />
//       <div>
//         <center><h1>All Bills</h1></center>
//         <div style={{ margin: '20px' }}>
//           <input
//             type="text"
//             placeholder="Search by Invoice Id or Customer Name"
//             value={searchTerm}
//             onChange={handleSearch}
//             style={{
//               padding: '10px',
//               width: '50%',
//               borderRadius: '5px',
//               border: '1px solid #ddd',
//               marginBottom: '20px'
//             }}
//           />
//         </div>
//         {selectedInvoices.length > 0 && (
//   <div style={{ margin: "20px" }}>
//     <button onClick={handleBulkPrint} style={{ marginRight: "10px" }}>
//       Print All
//     </button>
//     <button onClick={handleBulkLoadsheet} style={{ marginRight: "10px" }}>
//       LoadSheet All
//     </button>
//     <button onClick={handleBulkDelete} style={{ color: "red" }}>
//       Delete All
//     </button>
//   </div>
// )}

//         <div style={{ display: 'flex', flexDirection: 'column' }}>
//           {filteredBills.map(bill => (
//             <div
//   key={bill.id}
//   className='card'
//   style={{
//     border: '1px solid #ddd',
//     padding: '10px',
//     margin: '10px',
//     width: '95%',
//     borderRadius: '5px',
//     boxShadow: '0 0 10px rgba(0,0,0,0.1)',
//     position: 'relative'
//   }}
// >
//   <input
//   type="checkbox"
//   checked={selectedInvoices.includes(bill.id)}
//   onChange={() => toggleInvoiceSelection(bill.id)}
// />

//   <div className="card-content" onClick={() => handleDetails(bill.id)}>
//     <div className="bill-info">
//       <h3>Invoice ID: {bill.id}</h3>
//       <h3>Customer: {bill.customer_name}</h3>
//       <p><strong>Received:</strong> {bill.received}</p>
//       <p><strong>Pending:</strong> {bill.pending}</p>
//     </div>

//     {/* Buttons container */}
//     <div className="button-group">
//       <button onClick={() => handleWithPending(bill.id, bill.customer_id)}
//         className="action-btn black">
//         <MdOutlinePendingActions /> <span>With Pending</span>
//       </button>

//       <button onClick={() => handlePrintLoad(bill.id, bill.customer_id)}
//         className="action-btn primary">
//         <HiArrowCircleDown /> <span>Load Sheet</span>
//       </button>

//       <button onClick={() => handlePrint(bill.id, bill.customer_id)}
//         className="action-btn primary">
//         <IoIosPrint /> <span>Print</span>
//       </button>

//       <button onClick={() => handleEdit(bill.id)}
//         className="action-btn green">
//         <MdEdit /> <span>Edit</span>
//       </button>

//       <button onClick={() => handleDelete(bill.id)}
//         className="action-btn red">
//         <MdDelete /> <span>Delete</span>
//       </button>
//     </div>
//   </div>
// </div>

//           ))}
//         </div>
//       </div>
//       <br /><br /><br /><br />
//       <Footer />
//       <style>
// {`
//   .card-content {
//     display: flex;
//     justify-content: space-between;
//     align-items: flex-start;
//     flex-wrap: wrap;
//   }

//   .bill-info {
//     flex: 1;
//     min-width: 250px;
//   }

//   .button-group {
//     display: flex;
//     gap: 10px;
//     flex-wrap: wrap;
//     justify-content: flex-end;
//     align-items: center;
//   }

//   .action-btn {
//     display: flex;
//     align-items: center;
//     gap: 5px;
//     font-size: 16px;
//     padding: 8px 12px;
//     border-radius: 6px;
//     border: none;
//     cursor: pointer;
//     background: #f7f7f7;
//     box-shadow: 0 1px 3px rgba(0,0,0,0.1);
//     transition: all 0.2s ease-in-out;
//   }

//   .action-btn:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 4px 8px rgba(0,0,0,0.15);
//   }

//   .action-btn span {
//     font-size: 14px;
//   }

//   .action-btn.primary { color: ${Colors.primary}; }
//   .action-btn.green { color: green; }
//   .action-btn.red { color: red; }
//   .action-btn.black { color: black; }

//   /* Responsive for mobile */
//   @media (max-width: 768px) {
//     .card-content {
//       flex-direction: column;
//       align-items: flex-start;
//     }
//     .button-group {
//       width: 100%;
//       justify-content: flex-start;
//       flex-direction: column;
//       margin-top: 15px;
//     }
//     .action-btn {
//       width: 100%;
//       justify-content: flex-start;
//     }
//   }
// `}
// </style>

//     </>
//   );
// };

// export default BillPage;
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";
import { MdEdit, MdDelete, MdOutlinePendingActions } from "react-icons/md";
import { HiArrowCircleDown } from "react-icons/hi";
import { IoIosPrint } from "react-icons/io";
import Colors from "../components/Colors";
import "./styesheet.css";
import { pdfLink } from "../components/Strings";

const BillPage = () => {
  const [bills, setBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeLocation, setActiveLocation] = useState("All");
  const navigate = useNavigate();
  const [selectedInvoices, setSelectedInvoices] = useState([]);

  const toggleInvoiceSelection = (id) => {
    setSelectedInvoices((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleBulkPrint = () => {
    if (selectedInvoices.length === 0) return;
    const ids = selectedInvoices.join(",");
    const url = `${pdfLink}/printInvoicesBulk.php?ids=${ids}`;
    window.open(url, "_blank");
  };

  const handleBulkLoadsheet = () => {
    if (selectedInvoices.length === 0) return;
    const ids = selectedInvoices.join(",");
    const url = `${pdfLink}/loadsheetBulk.php?ids=${ids}`;
    window.open(url, "_blank");
  };

  const handleBulkDelete = async () => {
    if (selectedInvoices.length === 0) return;
    const ids = selectedInvoices.join(",");
    const response = await fetch(
      `https://app.mirzawaleed.com/deleteBillsBulk.php?ids=${ids}`
    );
    const data = await response.json();
    if (data.success) {
      window.location.reload();
    } else {
      console.error(data.message);
    }
  };

  useEffect(() => {
    const fetchBills = async () => {
      try {
        const response = await fetch("https://app.mirzawaleed.com/getBills.php");
        const data = await response.json();
        if (data.success) {
          setBills(data.bills);
          setFilteredBills(data.bills);
        } else {
          console.error(data.message);
        }
      } catch (error) {
        console.error("Error fetching bills:", error);
      }
    };

    fetchBills();
  }, []);

  // Get all unique locations
  const locations = ["All", ...new Set(bills.map((b) => b.customer_location))];

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    filterBills(e.target.value, activeLocation);
  };

  const handleTabChange = (location) => {
    setActiveLocation(location);
    filterBills(searchTerm, location);
  };

  const filterBills = (searchTerm, location) => {
    let filtered = bills;

    if (location !== "All") {
      filtered = filtered.filter((b) => b.customer_location === location);
    }

    if (searchTerm) {
      const lowerCaseSearchTerm = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (bill) =>
          bill.id.toString().includes(lowerCaseSearchTerm) ||
          bill.customer_name.toLowerCase().includes(lowerCaseSearchTerm)
      );
    }

    setFilteredBills(filtered);
  };

  const handlePrint = (invoiceId, customerId) => {
    const url = `${pdfLink}/printInvoice.php?invoice_id=${invoiceId}&customer_Id=${customerId}`;
    window.open(url, "_blank");
  };

  const handlePrintLoad = (invoiceId) => {
    const url = `${pdfLink}/loadsheet.php?invoice_id=${invoiceId}`;
    window.open(url, "_blank");
  };

  const handleEdit = (invoiceId) => {
    navigate(`/edit-invoice/${invoiceId}`);
  };
    const handleFullEdit = (invoiceId) => {
    navigate(`/editinvoice/${invoiceId}`);
  };

  const handleDelete = async (invoiceId) => {
    try {
      const response = await fetch(
        `https://app.mirzawaleed.com/deleteBills.php?id=${invoiceId}`
      );
      const data = await response.json();

      if (data.success) {
        window.location.reload();
      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error("Error deleting the bill:", error);
    }
  };

  const handleDetails = (invoiceId) => {
    navigate(`/invoice/${invoiceId}`);
  };

  const handleWithPending = (invoiceId, customerId) => {
    const pending = true;
    const url = `${pdfLink}/printInvoice.php?invoice_id=${invoiceId}&customer_Id=${customerId}&with_pending=${pending}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <Header />
      <br />
      <br />
      <br />
      <div style={{ margin: "20px" }}>
        <center>
          <h1>All Bills</h1>
        </center>

        {/* Tabs for Locations */}
        <div className="tabs">
          {locations.map((loc) => (
            <button
              key={loc}
              className={`tab ${activeLocation === loc ? "active" : ""}`}
              onClick={() => handleTabChange(loc)}
            >
              {loc}
            </button>
          ))}
        </div>

        {/* Search */}
        <div style={{ margin: "20px 0" }}>
          <input
            type="text"
            placeholder={`Search in ${activeLocation} invoices...`}
            value={searchTerm}
            onChange={handleSearch}
            style={{
              padding: "10px",
              width: "60%",
              borderRadius: "5px",
              border: "1px solid #ddd",
            }}
          />
        </div>

        {/* Bulk Actions */}
        {selectedInvoices.length > 0 && (
          <div style={{ marginBottom: "20px" }}>
            <h3 style={{margin:0}}>Selected: {selectedInvoices.length}</h3>
            <button onClick={handleBulkPrint} style={{ marginRight: "10px" }}>
              Print All
            </button>
            <button
              onClick={handleBulkLoadsheet}
              style={{ marginRight: "10px" }}
            >
              LoadSheet All
            </button>
            <button onClick={handleBulkDelete} style={{ color: "red" }}>
              Delete All
            </button>
          </div>
        )}

        {/* Invoice Cards */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          {filteredBills.map((bill) => (
            <div
              key={bill.id}
              className="card"
              style={{
                border: "1px solid #ddd",
                padding: "15px",
                margin: "10px",
                width: "95%",
                borderRadius: "8px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              }}
            >
              <input
                type="checkbox"
                checked={selectedInvoices.includes(bill.id)}
                onChange={() => toggleInvoiceSelection(bill.id)}
              />

              <div className="card-content">
                <div className="bill-info">
                  <p style={{fontWeight:"bold", textAlign:'center',background:'#4b3c7c', color:'white',padding:'12px',borderRadius:'12px', width:'90px'}}>{bill.date}</p>
                  <h3>Invoice ID: {bill.id}</h3>
                  <h3>Customer: {bill.customer_name}</h3>
                  <p>
                    <strong>Location:</strong> {bill.customer_location}
                  </p>
                  <p>
                    <strong>Received:</strong> {bill.received}
                  </p>
                  <p>
                    <strong>Pending:</strong> {bill.pending}
                  </p>
                </div>

                <div className="button-group">
                  <button
                    onClick={() => handleWithPending(bill.id, bill.customer_id)}
                    className="action-btn black"
                  >
                    <MdOutlinePendingActions /> <span>With Pending</span>
                  </button>

                  <button
                    onClick={() => handlePrintLoad(bill.id)}
                    className="action-btn primary"
                  >
                    <HiArrowCircleDown /> <span>Load Sheet</span>
                  </button>

                  <button
                    onClick={() => handlePrint(bill.id, bill.customer_id)}
                    className="action-btn primary"
                  >
                    <IoIosPrint /> <span>Print</span>
                  </button>

                  <button
                    onClick={() => handleEdit(bill.id)}
                    className="action-btn green"
                  >
                    <MdEdit /> <span>Edit Prices</span>
                  </button>
                  <button
                    onClick={() => handleFullEdit(bill.id)}
                    className="action-btn green"
                  >
                    <MdEdit /> <span>Edit Invoice</span>
                  </button>


                  <button
                   onClick={() => handleDetails(bill.id)}
                    className="action-btn green"
                  >
                    <span>Open</span>
                  </button>

                  <button
                    onClick={() => handleDelete(bill.id)}
                    className="action-btn red"
                  >
                    <MdDelete /> <span>Delete</span>
                  </button>
                </div>
              </div>
            </div>
          ))}

          {filteredBills.length === 0 && (
            <p style={{ textAlign: "center", color: "#777" }}>
              No invoices found.
            </p>
          )}
        </div>
      </div>
      <br />
      <br />
      <br />
      <Footer />

      {/* Inline CSS */}
      <style>
        {`
          .tabs {
            display: flex;
            gap: 10px;
            margin-bottom: 20px;
            flex-wrap: wrap;
          }

          .tab {
            padding: 10px 15px;
            border-radius: 6px;
            border: 1px solid #ccc;
            background: #f7f7f7;
            cursor: pointer;
            transition: all 0.2s ease-in-out;
          }

          .tab:hover {
            background: #eee;
          }

          .tab.active {
            background: ${Colors.primary};
            color: white;
            border-color: ${Colors.primary};
          }

          .card-content {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
          }

          .bill-info {
            flex: 1;
            min-width: 250px;
          }

          .button-group {
            display: flex;
            gap: 10px;
            flex-wrap: wrap;
            justify-content: flex-end;
            align-items: center;
          }

          .action-btn {
            display: flex;
            align-items: center;
            gap: 5px;
            font-size: 14px;
            padding: 8px 12px;
            border-radius: 6px;
            border: none;
            cursor: pointer;
            background: #f7f7f7;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
            transition: all 0.2s ease-in-out;
          }

          .action-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0,0,0,0.15);
          }

          .action-btn.primary { color: ${Colors.primary}; }
          .action-btn.green { color: green; }
          .action-btn.red { color: red; }
          .action-btn.black { color: black; }

          @media (max-width: 768px) {
            .card-content {
              flex-direction: column;
              align-items: flex-start;
            }
            .button-group {
              width: 100%;
              justify-content: flex-start;
              flex-direction: column;
              margin-top: 15px;
            }
            .action-btn {
              width: 100%;
              justify-content: flex-start;
            }
          }
        `}
      </style>
    </>
  );
};

export default BillPage;
